import {useLinkTo} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {FaChevronCircleRight, FaComment, FaPlusCircle} from 'react-icons/fa';
import {Dimensions, FlatList, StyleSheet, View} from 'react-native';
import {ListItem} from 'react-native-elements';
import {toast} from 'react-toastify';
import Emitter from '../components/Emitter';
import HomeHeader from '../components/HomeHeader';
import Loading from '../components/Loading';
import {listAllComplaints} from '../network/Network';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

function Itemview(props) {

  const linkTo = useLinkTo();
  
  const onPress = () => {
    linkTo('/customers/reply_to_complaint/?complaint=' + JSON.stringify(props.item));
  };

  return (
    <ListItem
      onPress={onPress}
      bottomDivider
      style={styles.listItemStyle}
      containerStyle={styles.listItemContainerStyle}>
      <FaComment size={15} color="white" />
      <ListItem.Content>
        <ListItem.Title
          allowFontScaling={true}
          numberOfLines={1}
          style={styles.listItemOpeningRemarkTitleStyle}>
          {props.item.opening_remark}
        </ListItem.Title>
        <ListItem.Subtitle style={styles.listItemLastUpdatedSubtitleStyle}>
          Last Updated at {props.item.updated_at.split(' ')[0]}
        </ListItem.Subtitle>
      </ListItem.Content>
      <ListItem.Title style={styles.listItemIsClosedTitleStyle}>
        {props.item.is_closed === 0 ? 'Active' : 'Closed'}
      </ListItem.Title>
      <FaChevronCircleRight size={15} color="white" />
    </ListItem>
  );
}

export default function CrmScreen(props) {
  
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const linkTo = useLinkTo();

  useEffect(() => {
    Emitter.on('crmload', (load) => {
      if (load) {
        fetchAllComplaints();
      }
    });

    fetchAllComplaints();
    return () => {
      Emitter.off('crmload');
    };
  }, []);

  const fetchAllComplaints = () => {
    setLoading(true);
    listAllComplaints()
      .then((reply) => {
        if (reply.success && (reply.status === 200 || reply.status === 201)) {
          setComplaints(reply.data);
          setLoading(false);
          if (reply.data.length == 0) {
            toast('Nothing to show here');
          }
        }
      })
      .catch((r) => {
        console.log(r);
        toast('Error, please try again');
        setLoading(false);
      });
  };

  const renderer = ({item, index}) => (
    <Itemview navigation={props.navigation} item={item} index={index} />
  );

  const keyExtractor = (item, index) => index.toString();

  const onPlusIconPress = () => {
    linkTo('/customers/categories');
  };

  return (
    <View style={styles.viewStyle}>
      <HomeHeader navigation={props.navigation} />
      {loading ? (
        <View style={styles.indicatorStyle}>
          <Loading />
        </View>
      ) : (
        <Container>
          <Row>
            <Col md={3}></Col>
            <Col md={6}>
              <Button
                onClick={onPlusIconPress}
                style={{
                  backgroundColor: '#e10808',
                  float: 'right',
                  margin: 16,
                  justifyContent: 'center',
                }}
                variant="danger">
                <FaPlusCircle
                  style={{
                    justifySelf: 'center',
                    marginRight: 5,
                  }}
                />{' '}
                File Complaint
              </Button>
            </Col>
            <Col md={3}></Col>
          </Row>
          <Row>
            <Col md={3}></Col>
            <Col md={6}>
              <FlatList
                contentContainerStyle={styles.flatListContentContainerStyle}
                data={complaints}
                keyExtractor={keyExtractor}
                renderItem={renderer}
              />
            </Col>
            <Col md={3}></Col>
          </Row>
        </Container>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT
  },
  indicatorStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  flatListContentContainerStyle: {
    paddingBottom: 500,
    paddingTop: 10,
  },
  iconButtonViewStyle: {
    position: 'absolute',
    bottom: 50,
    right: 50,
  },
  listItemContainerStyle: {
    backgroundColor: '#e10808',
  },
  listItemStyle: {
    marginHorizontal: 20
  },
  listItemOpeningRemarkTitleStyle: {
    color: 'white',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'bold',
  },
  listItemLastUpdatedSubtitleStyle: {
    color: 'white',
    fontSize: 12,
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
  listItemIsClosedTitleStyle: {
    textTransform: 'uppercase',
    color: 'white',
    fontSize: 15,
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'bold',
  },
});
